import React from 'react'
import {TabPanel} from "@chakra-ui/react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import MultiLanguageFeatureTableProgress from "./MultiLanguageFeatureTableProgress.tsx";
import {IGroupProgress} from "../../models/interfaces/groupProgress.interface.ts";
import TranscriptionFeatureProgress from "./TranscriptionFeatureProgress.tsx";


interface SubtitlesTranscreationFeatureProgressProps {
  project: IProject;
}

const SubtitlesTranscreationFeatureProgress: React.FC<SubtitlesTranscreationFeatureProgressProps> = (
  {
    project
  }: SubtitlesTranscreationFeatureProgressProps) => {

  return (
    <TabPanel>
      <div className="overflow-hidden rounded-md border border-n-600">
        <MultiLanguageFeatureTableProgress
          projectId={project.id}
          projectName={project.name}
          feature={project.featuresStates.subtitleTranslations || {} as IGroupProgress}
          featureName={"subtitleTranslations"}
        >
          <TranscriptionFeatureProgress project={project}/>
        </MultiLanguageFeatureTableProgress>
      </div>
    </TabPanel>
  )
}

export default SubtitlesTranscreationFeatureProgress;